import {Component, Input, OnInit, Output, EventEmitter, OnChanges} from "@angular/core";
import { IAnswer, IFormField, makeControlForQuestion } from "../../../../../../shared/components/form-field-wrapper/form-field-wrapper.component";
import { TaxReturnSubcategoryService } from "../../subcategory.service";
import { cloneDeep } from "lodash-es";
import { subcategoryTabs } from "../../subcategory.const";
import {ClearOverRides, TaxReturnService} from "../../../../../../../swaggerServices";

declare var $: any;

@Component({
    selector: "app-question-table-row",
    templateUrl: "./question-table-row.component.html",
    styleUrls: ["./question-table-row.component.scss"],
    standalone: false
})
export class QuestionTableRowComponent implements OnInit, OnChanges {
  @Input() readonly;
  @Input() readonlyGlobal;
  @Input() deleted;
  @Input() inspectMode;
  @Input() subGroup;
  @Input() formGroup;
  @Input() groupId;
  @Input() rowIndex;
  @Input() rowAnswer;
  @Input() isSelected = false;
  @Input() hideClearOverRideQuestionIcon = false;

  @Output() loadTrace = new EventEmitter();
  @Output() selectRow = new EventEmitter();
  @Output() refreshTaxReturn: EventEmitter<any> = new EventEmitter();

  tableCells;
  constructor(private taxReturnSubcategoryService: TaxReturnSubcategoryService, private taxReturnService: TaxReturnService) {
  }

  ngOnInit() {
    this.tableCells = this.getTableCells();
  }

  ngOnChanges(changes) {
    if (changes.subGroup) {
      this.tableCells = this.getTableCells();
    }
  }

  showOverRideQuestion(ans: any) {
    return ( ans && ans.overrideStatus && ans.answer !== '' && !this.hideClearOverRideQuestionIcon);
  }
  overRideAnswer(ans: any, cell: any) {
    if ( ans && ans.overrideStatus && ans.answer !== '' && this.tableCells && this.tableCells.length ) {
      if (window.confirm("Are you sure you want to clear overrides for this question?")) {
        let remainingAnswersLength = 0;
        this.tableCells.forEach(c => {
          if ( c.answer && c.answer.answer && c.answer.answer !== '' && c.answer.id !== ans.id ) {
            remainingAnswersLength++;
          }
        });
        const taxReturnId = ( ans && ans.taxReturnId ) ? ans.taxReturnId : 0;
        let answerIds = [];
        if ( remainingAnswersLength === 0 ) {
          answerIds.push(ans.parentAnswerId );
        }
        answerIds.push(ans.id);

        const clearOverRidesBody: ClearOverRides = {
          clearRowIdFlag: ( remainingAnswersLength === 0 ) ? true : false,
          rowAnswerQuestionId: ( remainingAnswersLength === 0 ) ? ans.questionId : null,
          updateAnswerFlag: true,
          answerIds
        };

        this.taxReturnService.clearOverridesForTaxReturn(taxReturnId, clearOverRidesBody ).subscribe(result => {
          this.refreshTaxReturn.emit(true);
        });
      }
    }
  }
  getDisplayAnswer(cell) {
    const q = cell.question;
    const answerValue = cell.formControl ? cell.formControl.value : cell.answer.answer;
    if (q.displayFieldType === "drop down") {
      const selectedDropdown = answerValue ? q.questionDropdowns.find(qd => qd.value === answerValue) : null;
      return selectedDropdown != null && selectedDropdown.display || answerValue;
    }
    return answerValue;
  }


  cellClick(cell) {
    if(this.inspectMode) {
      this.labelClick(cell.question, cell.answer);
    } else {
      this.focusTableInput(cell);
    }
  }

  labelClick(cellQuestion, cellAnswer) {
    const currentTab = this.taxReturnSubcategoryService.currentTab;
    if (this.inspectMode === 'trace') {
      this.loadTrace.emit({question: cellQuestion, answer: cellAnswer});
    } else if (currentTab === subcategoryTabs.flags) {
      this.flagCell(cellQuestion, cellAnswer);
    } else if(!this.readonly && currentTab === subcategoryTabs.comments) {
      this.commentCell(cellQuestion);
    }
  }

  onCellBlur(cell) {
    cell.answer.isActive = false;
    this.handleAnswerChange(cell);
  }

  isCellHasMandatoryWarning(cell: any) {
    if ( cell && cell.question && cell.question.mandatory && ( !cell.formControl || !cell.formControl.value) ) {
      return true;
    }
    if ( this.formGroup && this.formGroup.get(String(cell.question.dependantMandatoryParentId)) ) {
      const parentAnswer = this.formGroup.get(String(cell.question.dependantMandatoryParentId)).value;
      if ( parentAnswer && parentAnswer !== '' ) {
              let mandatory = (!cell.formControl || !cell.formControl.value) ? true : false;
               if ( cell.question.dependantMandatoryParentValue )  {
                  mandatory  = ( cell.question.dependantMandatoryParentValue === parentAnswer && (!cell.formControl || !cell.formControl.value)) ? true : false;
               }
               return mandatory;
      }

   }
    return false;
  }

  hasWarnings(answer?: IAnswer, activeOnly?: boolean) {
    return answer && answer.answerWarnings && (activeOnly ? answer.answerWarnings.filter(w => w.status === 0).length > 0 : answer.answerWarnings.length > 0);
  }

  hasFlags(answer?: IAnswer, activeOnly?: boolean) {
    return answer && answer.answerFlags && (activeOnly ? answer.answerFlags.filter(f => f.status === 0).length > 0 : answer.answerFlags.length > 0);
  }

  hasComments(answer?: IAnswer) {
    return answer && answer.comments && answer.comments.filter(c => !c.answerWarningId && !c.answerFlagId).length > 0
  }

  private focusTableInput(cell) {
    if (this.readonly || this.deleted) return false;
    if(!cell.formControl){
      cell.formControl = makeControlForQuestion(cell.question, true, cell.answer)

      this.formGroup.addControl(`${cell.question.id}-${cell.rowIndex}`, cell.formControl);
    }

    if (cell.question.isBooleanCheckbox) {
      const val = cell.formControl.value ? '' : 'true';
      cell.formControl.setValue(val);
      this.handleAnswerChange(cell);
    } else {
      cell.answer.isActive = true;
    }
  }

  private handleAnswerChange(cell) {
    cell.question.subGroupId = this.subGroup.id;
    cell.question.subGroupName = this.subGroup.name;

    const originalAnswer = cell.answer && !cell.answer.isNew && cell.answer.answer != null ? cell.answer.answer : '';
    const valueHasChangedFromOriginal = cell.formControl.value !== originalAnswer;

    const commentField = cloneDeep(cell.question);
    commentField.answerChanged = valueHasChangedFromOriginal;
    commentField.rowIndex = this.rowIndex;

    // remove from array if val is same as previous
    if (!valueHasChangedFromOriginal) {
      cell.answer.answerChanged = false;
      this.taxReturnSubcategoryService.removeCommentField(commentField);
    } else {
      cell.answer.answerChanged = true;
      cell.displayAnswer = this.getDisplayAnswer(cell);
      if (this.taxReturnSubcategoryService.commentFieldExist(commentField)) {
        // Edit when the commentField was not due to an answer change, but now is
        this.taxReturnSubcategoryService.removeCommentField(commentField);
        this.taxReturnSubcategoryService.addCommentField(commentField);
      } else if (!this.readonly) {
        // Just add it
        this.taxReturnSubcategoryService.addCommentField(commentField);
      }
    }
  }

  private getFormControl(q) {
    return this.rowIndex != null ? this.formGroup.get(`${q.id}-${this.rowIndex}`) : this.formGroup.controls[q.id];
  }

  private getTableCells() {
    const row = this.subGroup.rows[this.rowIndex];
    const cells = this.subGroup.questions.filter(q => !q.hidden).map(columnQuestion => {
      const cellAnswer = row.cells[columnQuestion.id];
      const control = this.getFormControl(columnQuestion);
      columnQuestion.isBooleanCheckbox = columnQuestion.displayFieldType === 'checkbox' && columnQuestion.dataType === 'boolean';
      columnQuestion.dropdownDirection = 'downward';
      const cell = {
        question: columnQuestion,
        answer: cellAnswer,
        formControl: control,
        rowIndex: this.rowIndex,
        displayAnswer:""
      }
      cell.displayAnswer = this.getDisplayAnswer(cell)
      return cell;
    });
    return cells;
  }

  private flagCell(question, answer?: IAnswer) {
    if (!this.readonly) {
      const flagAns = cloneDeep(question);
      flagAns.answerId = answer && answer.id;
      flagAns.groupId = this.groupId;
      if (this.subGroup) {
        flagAns.subGroupId = this.subGroup.id;
        flagAns.subGroupName = this.subGroup.name;
      }
      if (this.rowIndex != null) {
        flagAns.rowIndex = this.rowIndex;
      }
      flagAns.row = this.rowAnswer;
      this.taxReturnSubcategoryService.setFlaggedAns(flagAns);
    }
  }

  private commentCell(question) {
    const commentField = cloneDeep(question);
    commentField.rowIndex = this.rowIndex;
    commentField.groupId = this.groupId;
    if (this.subGroup) {
      commentField.subGroupId = this.subGroup.id;
      commentField.subGroupName = this.subGroup.name;
    }

    this.taxReturnSubcategoryService.addCommentField(commentField);
  }

  isQuestionAlwaysEditable(question: IFormField, rOnly: boolean) {
    return ( question && question.alwaysEditable ) ? undefined : !rOnly ? undefined : ( this.inspectMode === 'trace' ? undefined : true);
  }
}
